/*
  Project: Vivafloors
 */

// 'Vraag deze bundel aan', see templates/components/bundle-button.php. The
// server puts the 3 samples in 'Mijn stalen'; the checkout does the rest.
jQuery(function ($) {

  const $modal = $('.js-form-modal').first();

  // Same popup as a fourth sample gets (templates/components/modal.php), in
  // its bundle state. Only the limit and added states are hidden here;
  // favoriteModal.js hides this one again when a product opens the popup.
  const showModal = function (data) {
    $modal.find('.js-form-modal__added, .js-form-modal__limit').prop('hidden', true);
    $modal.find('.js-form-modal__bundle-title').text(data.title || '');
    $modal.find('.js-form-modal__bundle-text').text(data.message || '');
    $modal.find('.js-form-modal__bundle').prop('hidden', false);

    $modal.addClass('active loaded');
    $('body').addClass('no-scroll');
  };

  // favoriteModal.js only binds its close buttons after a product click.
  $modal.on('click', '.js-close-modal', function () {
    $modal.removeClass('active loaded');
    $('body').removeClass('no-scroll');
  });

  // Without the popup on the page, the message goes under the button.
  const showMessage = function ($message, data) {
    $message.text([data.title, data.message].filter(Boolean).join('. '));

    if (data.link) {
      $message.append(' ', $('<a>', { href: data.link.url, text: data.link.title }));
    }

    $message.prop('hidden', false);
  };

  // 'Meer bundels tonen' on desktop, see page-gratis-stalen-aanvragen.php.
  // app.bundle.js can be on a page twice (header.php and custom_gform_init()),
  // and a second handler would fold the grid straight back up, so it's bound
  // only once.
  $(document).off('click.bundlesMore').on('click.bundlesMore', '.js-bundles-more', function () {
    const $button = $(this);
    const $grid = $('#' + $button.attr('aria-controls'));
    const isExpanded = !$grid.hasClass('is-expanded');

    if (!$button.data('label-more')) {
      $button.data('label-more', $button.text().trim());
    }

    $grid.toggleClass('is-expanded', isExpanded);
    $button
      .attr('aria-expanded', isExpanded ? 'true' : 'false')
      .text(isExpanded ? $button.data('label-less') : $button.data('label-more'));
  });

  $(document).on('click', '.js-add-bundle', function () {
    const $button = $(this);
    const $message = $button.closest('.js-add-bundle-wrapper').find('.js-add-bundle-message');

    if ($button.prop('disabled')) return;

    $button.prop('disabled', true);
    $message.prop('hidden', true).empty();

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: window.location.protocol + '//' + window.location.host + '/wp-admin/admin-ajax.php',
      data: {
        action: 'vivafloors_add_bundle',
        bundle_id: $button.data('bundle'),
      },
    }).done(function (response) {
      if (response.success) {
        window.location.href = response.data.redirect;
        return;
      }

      if ($modal.length) {
        showModal(response.data || {});
      } else {
        showMessage($message, response.data || {});
      }

      $button.prop('disabled', false);
    }).fail(function () {
      $button.prop('disabled', false);
    });
  });

});



// WEBPACK FOOTER //
// ./src/scripts/modules/bundles.js